
import React, { useState, useEffect } from 'react';
// import { Link } from 'react-router-dom';
import Axios from 'axios';
import { API_BASE_URL, VIEW_COMBO_PRODUCTS } from '../../../Config';
import PropTypes from 'prop-types';


const ViewComboProduct = ({ viewObj }) => {

    // console.log(viewObj, 'v v v v v')

    const [userDataSession, setUserDataSession] = useState([]);
    const [comboProductsData, setComboProductsData] = useState([]);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        const userDataString = sessionStorage.getItem("userData");
        if (userDataString) {
            const userData = JSON.parse(userDataString);
            setUserDataSession(userData);

        } else {
            console.log("User data not found in sessionStorage");
        }
    }, []);

    useEffect(() => {
        if (userDataSession && userDataSession.OrgId) {
            setLoading(true);

            Axios.get(`${API_BASE_URL}${VIEW_COMBO_PRODUCTS}?OrgId=${userDataSession.OrgId}&MainProductId=${viewObj.MainProductId}`)
                .then(response => {
                    if (response.data.Status) {
                        setLoading(false);
                        setComboProductsData(response.data.ResultData);
                    } else {
                        setLoading(false);
                        console.error('Error fetching data:', response.data);
                    }
                })
                .catch(error => {
                    setLoading(false);
                    console.error('Error fetching data:', error);
                });
        }
    }, [userDataSession, viewObj]);

    return (
        <div>
            {/* View Combo Product */}
            <div className="modal fade mt-5" id="view-combo-product">
                <div className="modal-dialog modal-dialog-centered custom-modal-two">
                    <div className="modal-content">
                        <div className="page-wrapper-new p-0">
                            <div className="content">
                                <div className="modal-header border-0 custom-modal-header">
                                    <div className="page-title">
                                        <h4>View Combo Product</h4>
                                    </div>
                                    <button
                                        type="button"
                                        className="close d-flex ms-auto"
                                        data-bs-dismiss="modal"
                                        aria-label="Close"
                                    >
                                        <span aria-hidden="true">×</span>
                                    </button>
                                </div>
                                <div className="modal-body custom-modal-body">
                                    <form>
                                        <div className="col-12 table-responsive" style={{ maxHeight: '15rem', overflowY: 'auto' }}>
                                            <table className="table datanew">
                                                <thead>
                                                    <tr>
                                                        <th>#</th>
                                                        <th>Product</th>
                                                        <th>Quantity</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {loading ? (
                                                        <tr>
                                                            <td colSpan="3">
                                                                <div className="d-flex justify-content-center align-items-center" >
                                                                    <div className="loader">
                                                                        {/* <span className="sr-only">Loading...</span> */}
                                                                    </div>
                                                                </div>
                                                            </td>
                                                        </tr>
                                                    ) : (
                                                        comboProductsData.map((child, index) => (
                                                            <tr key={child.value}>
                                                                <td>{index + 1}</td>
                                                                <td>{child.ChildProductName}</td>
                                                                <td>{child.Quantity}</td>
                                                            </tr>
                                                        ))
                                                    )}
                                                </tbody>
                                            </table>
                                        </div>
                                        <div className="modal-footer-btn">
                                            <button
                                                type="button"
                                                className="btn btn-cancel me-2"
                                                data-bs-dismiss="modal"
                                                // onClick={handleCancelBtnClick}
                                            >
                                                Cancel
                                            </button>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* /Add Combo Product */}
        </div>
    )
}

ViewComboProduct.propTypes = {
    viewObj: PropTypes.object.isRequired,
};

export default ViewComboProduct
